import { http } from '../core/http';
import type { LoginRequest, MeResponse } from './types';

export const authApi = {
  login: (payload: LoginRequest) => http.post<MeResponse>('/auth/login', payload),
  me: () => http.get<MeResponse>('/auth/me'),
  heartbeat: () => http.get<void>('/auth/heartbeat'),
  logout: () => http.post<void>('/auth/logout', {}),
};
